import { createLogger } from "redux-logger";

const logger = createLogger({
    collapsed: false,
    diff: true,
  });

export default logger;